import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { getContentPage } from "store/actions";
import { useSelector, useDispatch } from "react-redux";
 
export default function AboutPage() {
  const dispatch = useDispatch();

  const { content } = useSelector((state) => state?.contentpage);

  
  useEffect(() => {
    dispatch(getContentPage());
  }, []);


  const getContent = () =>{
    return content?.length && content?.find((item)=> item?.slug === "about")?.content;
  } 


  return (
    <section className="Browsemuseums Termscenter">
      <Container>
        <div className="Browsemuseums-para Termscenter">
          <h3>{content[2]?.title || ""}</h3>
          <div
            dangerouslySetInnerHTML={{
              __html: getContent() || "",
            }}
          />
        </div>
      </Container>
    </section>
  );
}
